import React, { Component } from "react";
import PropTypes from "prop-types";

import ninjaville_login_logo from "images/custom/login/login_graphic.png";
import LoginPoweredByImageRow from "./LoginPoweredByImageRow";

import localize from "lang/localize";

const propTypes = {
  isTour: PropTypes.bool
};

const defaultProps = {
  isTour: false
};

class LoginImageRow extends Component {
  render() {
    return (
      <div
        className={
          "pure-g topmargin-30" + (this.props.isTour ? "" : " innerblock")
        }
      >
        <div className="pure-u-1-8 pure-u-sm-5-24 pure-u-md-7-24" />
        <div className="pure-u-3-4 pure-u-sm-14-24 pure-u-md-10-24">
          <img
            src={ninjaville_login_logo}
            className="imgresponsive ninjaville-logo"
            alt={localize("ninjaville_title", this.props.language)}
          />
        </div>
        <div className="pure-u-1-8 pure-u-sm-5-24 pure-u-md-7-24" />
        {this.props.isTour ? null : <LoginPoweredByImageRow />}
      </div>
    );
  }
}

LoginImageRow.propTypes = propTypes;
LoginImageRow.defaultProps = defaultProps;

export default LoginImageRow;
